import { Row, Space, Typography, Table } from "antd"
import { useEffect, useState } from "react"
import { useRecoilValue, useRecoilState } from "recoil"
import { useNavigate } from "react-router-dom"
import { allSitesAtom } from "../../Atoms/allSitesAtom"
import { useCookies } from 'react-cookie';
import { useAuthenticator } from '@aws-amplify/ui-react'
import DashboardCard from "../../Components/DashboardCard"
// import { 
//   offlineCount, 
//   offlineUnits, 
//   lowAcidCount, 
//   lowAcidUnits, 
//   lowSaltCount, 
//   lowSaltUnits, 
//   orpRangeCount, 
//   orpRangeUnits, 
//   phRangeCount, 
//   phRangeUnits,
//   equipmentCount,
//   equipmentUnits
// } from "../../Helpers/kpis"
// import { formatTimestamp } from '../../Helpers/formatTimestamp.js'
import "./Dashboard.css"

function Dashboard() {
  const navigate = useNavigate();
  const allSites = useRecoilValue(allSitesAtom)
  const { user } = useAuthenticator((context) => [context.user]);
  let email = ''
  if(user?.attributes?.email) email = user?.attributes?.email
  const [kpis, setKpis] = useState({totalUnits: 0, offlineUnits: 0, lowAcidUnits: 0, lowSaltCount: 0, phRangeCount: 0, orpRangeCount: 0})
  const [data, setData] = useState({title: "", units: []})
  const [cookies, setCookie] = useCookies([email]);
  const { Title } = Typography;
  // const columns = [
  //   {
  //     title: "Owner",
  //     dataIndex: "email",
  //     key: "user",
  //   },
  //   {
  //     title: "Pool",
  //     dataIndex: "poolName",
  //     key: "pool",
  //   },
  //   {
  //     title: "Acid Level",
  //     dataIndex: "acidVolume",
  //     key: "acidVolume",
  //     render: (_, record) => {
  //       return record.hasOwnProperty("acidVolume") ? `${Math.round(record.acidVolume * 100) / 100}%` : "N/A"
  //     },
  //   },
  //   {
  //     title: "Salinity",
  //     dataIndex: "salt",
  //     key: "salt",
  //     render: (_, record) => {
  //       return record.hasOwnProperty("salt") ? record.salt : "N/A"
  //     },
  //   },
  //   {
  //     title: "ORP",
  //     dataIndex: "orp",
  //     key: "orp",
  //     render: (_, record) => {
  //       return record.hasOwnProperty("orp") ? record.orp : "N/A"
  //     },
  //   },
  //   {
  //     title: "pH",
  //     dataIndex: "ph",
  //     key: "ph",
  //     render: (_, record) => {
  //       return record.hasOwnProperty("ph") ? record.ph : "N/A"
  //     },
  //   },
  //   {
  //     title: "Last Updated",
  //     dataIndex: "lastUpdated",
  //     key: "lastUpdated",
  //     render: (_, record) => {
  //       return (formatTimestamp(record.lastUpdated))
  //     },
  //   },
  //   {
  //     title: 'Action',
  //     key: 'action',
  //     render: (_, record) => {
  //       return (<Space size="middle">
  //         <a onClick={() => {
  //           navigate(`/site/${record.mac}`);
  //           }}>View</a>
  //       </Space>)
  //     },
  //   },
  // ]
  
  useEffect(() => {
    if(cookies[email]?.mac) navigate(`/site/${cookies[email].mac}`)
    // const unitSum = Object.values(allSites).reduce((sum, arr) => sum + arr.length, 0)
    // const chemIQSum = equipmentCount(allSites, "CHEM_IQ")
    // const dispenseIQSum = equipmentCount(allSites, "DISPENSE_IQ")
    // const levelIQSum = equipmentCount(allSites, "LEVEL_IQ")
    // // const chlorIQSum = equipmentCount(allSites, "CHLOR_IQ")
    // const triSenseIQSum = equipmentCount(allSites, "TRISENSE_IQ")
    // // const pressureIQSum = equipmentCount(allSites, "PRESSURE_IQ")
    // const jandySum = equipmentCount(allSites, "JANDY")
    // const intelliChlorSum = equipmentCount(allSites, "INTELLICHLOR")
    // const aquaRiteSum = equipmentCount(allSites, "AQUARITE")

    //This isn't the most efficient way to do this
    // setKpis({
    //   totalUnits: unitSum,
    //   chemIQSum: chemIQSum,
    //   dispenseIQSum: dispenseIQSum,
    //   levelIQSum: levelIQSum,
    //   // chlorIQSum: chlorIQSum,
    //   triSenseIQSum: triSenseIQSum,
    //   // pressureIQSum: pressureIQSum,
    //   jandySum: jandySum,
    //   intelliChlorSum: intelliChlorSum,
    //   aquaRiteSum: aquaRiteSum,
    //   offlineUnits: offlineCount(allSites), 
    //   lowAcidUnits: lowAcidCount(allSites), 
    //   lowSaltCount: lowSaltCount(allSites),
    //   phRangeCount: phRangeCount(allSites),
    //   orpRangeCount: orpRangeCount(allSites)
    // })
  }, [allSites,cookies,user]);

  return (
    <>
      <Title level={4}>Welcome to Stratus</Title>
      {/* <Row gutter={8} className="cardContainer">
        <div onClick={() => {
          const allUnits = [].concat(...Object.values(allSites))
          setData({title: "Installed ConnectIQ", units: allUnits});
        }}>
          <DashboardCard
            span={5}
            title={"ConnectIQ"}
            value={kpis.totalUnits}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Installed ChemIQ", units: equipmentUnits(allSites, "CHEM_IQ")});
        }}>
          <DashboardCard
            span={5}
            title={"ChemIQ"}
            value={kpis.chemIQSum}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Installed DispenseIQ", units: equipmentUnits(allSites, "DISPENSE_IQ")});
        }}>
          <DashboardCard
            span={5}
            title={"DispenseIQ"}
            value={kpis.dispenseIQSum}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Installed TriSenseIQ", units: equipmentUnits(allSites, "TRISENSE_IQ")});
        }}>
          <DashboardCard
            span={5}
            title={"TriSenseIQ"}
            value={kpis.triSenseIQSum}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Installed LevelIQ", units: equipmentUnits(allSites, "LEVEL_IQ")});
        }}>
          <DashboardCard
            span={5}
            title={"LevelIQ"}
            value={kpis.levelIQSum}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Installed Jandy Adapter", units: equipmentUnits(allSites, "JANDY")});
        }}>
          <DashboardCard
            span={5}
            title={"Jandy Adapter"}
            value={kpis.jandySum}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Installed Intellichlor Adapter", units: equipmentUnits(allSites, "INTELLICHLOR")});
        }}>
          <DashboardCard
            span={5}
            title={"Intellichlor Adapter"}
            value={kpis.intelliChlorSum}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Installed Aquarite Adpater", units: equipmentUnits(allSites, "AQUARITE")});
        }}>
          <DashboardCard
            span={5}
            title={"Aquarite Adapter"}
            value={kpis.aquaRiteSum}
            precision={0}
            hoverable={true}
          />
        </div>
      </Row>
      <Title level={4}>KPIs</Title>
      <Row gutter={16} style={{width: "75vw"}}>
        <div onClick={() => {
          setData({title: "Offline Units", units: offlineUnits(allSites)});
        }}>
          <DashboardCard
            span={5}
            title={"Offline Units"}
            value={kpis.offlineUnits}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Low Acid Level", units: lowAcidUnits(allSites)});
        }}>
          <DashboardCard
            span={5}
            title={"Low Acid Level"}
            value={kpis.lowAcidCount}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "Low Salt Level", units: lowSaltUnits(allSites)});
        }}>
          <DashboardCard
            span={5}
            title={"Low Salt Level"}
            value={kpis.lowSaltCount}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "ORP Out of Range", units: orpRangeUnits(allSites)});
        }}>
          <DashboardCard
            span={5}
            title={"ORP Range"}
            value={kpis.orpRangeCount}
            precision={0}
            hoverable={true}
          />
        </div>
        <div onClick={() => {
          setData({title: "pH Out of Range", units: phRangeUnits(allSites)});
        }}>
          <DashboardCard
            span={5}
            title={"pH Range"}
            value={kpis.phRangeCount}
            precision={0}
            hoverable={true}
          />
        </div>
      </Row> */}
      {data.units.length > 0 && 
        <>
          <Title level={4}>{data.title}</Title>
          {/* <Table columns={columns} dataSource={data.units} rowKey="data_id" /> */}
        </>
      }
    </>
  );
}

export default Dashboard;

// const columns = [
//   {
//     title: 'Name',
//     dataIndex: 'name',
//     key: 'name',
//     render: (text) => <a>{text}</a>,
//   },
//   {
//     title: 'Age',
//     dataIndex: 'age',
//     key: 'age',
//   },
//   {
//     title: 'Address',
//     dataIndex: 'address',
//     key: 'address',
//   },
//   {
//     title: 'Tags',
//     key: 'tags',
//     dataIndex: 'tags',
//     render: (_, { tags }) => (
//       <>
//         {tags.map((tag) => {
//           let color = tag.length > 5 ? 'geekblue' : 'green';
//           if (tag === 'loser') {
//             color = 'volcano';
//           }
//           return (
//             <Tag color={color} key={tag}>
//               {tag.toUpperCase()}
//             </Tag>
//           );
//         })}
//       </>
//     ),
//   },
//   {
//     title: 'Action',
//     key: 'action',
//     render: (_, record) => (
//       <Space size="middle">
//         <a>Invite {record.name}</a>
//         <a>Delete</a>
//       </Space>
//     ),
//   },
// ];
// const data = [
//   {
//     key: '1',
//     name: 'John Brown',
//     age: 32,
//     address: 'New York No. 1 Lake Park',
//     tags: ['nice', 'developer'],
//   },
//   {
//     key: '2',
//     name: 'Jim Green',
//     age: 42,
//     address: 'London No. 1 Lake Park',
//     tags: ['loser'],
//   },
//   {
//     key: '3',
//     name: 'Joe Black',
//     age: 32,
//     address: 'Sydney No. 1 Lake Park',
//     tags: ['cool', 'teacher'],
//   },
// ];
// const App = () => <Table columns={columns} dataSource={data} />;
